import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {watchTicketMutation, WatchTicketInput} from './__generated__/watchTicketMutation.graphql';

const mutation = graphql`
	mutation watchTicketMutation($input: WatchTicketInput!) {
		watchTicket(input: $input) {
			clientMutationId
			ticket {
				id
				isWatching
				watcherCount
				watchers {
					id
					person {
						id
						...ticketingPerson_person
					}
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: WatchTicketInput,
	onCompleted?: (r: watchTicketMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<watchTicketMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'watchTicketMutation'};
